export default {
    //AcademyComponent
    customization: 'Personalize a sua academia',
    sections: 'Secções de personalização',
    // Secciones del menú lateral: cada descripción nombra solo lo que hay en esa pantalla.
    identity: 'Identidade',
    identity_description: 'Nome, slogan, logótipo e favicon',
    design: 'Design',
    design_description: 'Cores e tipografias',
    home: 'Página inicial',
    home_description: 'Cabeçalho, banner e descrição',
    description_location_help: 'Onde aparece: com o cabeçalho «2 Colunas, Texto + Imagem» aparece junto à imagem, no topo da página inicial. Com os cabeçalhos de banner em tamanho real aparece na secção de contacto, no fim da página inicial.',
    menu_section_description: 'Ligações do menu do site',
    contact_social: 'Contacto e redes',
    contact_description: 'Contacto, redes e HTML próprio',
    legal_description: 'Privacidade e aviso legal',
    settings: 'Definições',
    settings_description: 'Domínio, idioma e scripts',
    domain: "Domínio",
    brand_logo: "Logótipo e marca",
    rrss_contact: "Contacto e RRSS",
    legal: "Legal",
    options: 'Opções',

    //DomainComponent
    your_domain: "O seu domínio mybrainspro.com",
    info_domain: "Digite o domínio SEM símbolos (.,-¿?!-$%&/()...), sotaques ou espaços. Não é necessário colocar www.",
    domain_input: "Domínio mybrainspro.com",
    custom_domain: "Domínio personalizado",
    info_domain2: "Introduza o seu domínio (www.tudominio.com) para o utilizar como página inicial ou como página secundária (yourdomain.yourdomain.com).",
    attention: "Atenção",
    info_attention: "Apenas disponível para os planos ADVANCED e PRO.",
    activate_domain: "Para activar o seu domínio em BrainsPro: ",
    info_activate_1line: "Visite a plataforma onde comprou o seu domínio e procure as definições DNS..",
    info_activate_2line: "Adiciona tipo de registo A ao IP: 76.223.11.227",
    info_activate_3line: "Note que pode levar até 48 horas para que estas alterações tenham efeito e se propaguem no seu DNS. Uma vez pronto, pode começar a usar o novo endereço da sua academia online BrainsPro.",
    info_activate_4line: "A equipa do brainspro contactá-lo-á para lhe enviar alguns registos adicionais que terá de colocar no seu DNS. Com eles iremos gerar o seu sítio web seguro (https://).",
    //LanguageSelector
    lang: 'Idioma',
    academy_lang: 'Língua da Academia',
    academy_lang_selector_text: 'Escolha a língua da sua academia',

    //BrandingComponent
    brand_academy: "Marcar a sua academia",
    academy_name: "Nome da Academia",
    full_name: "Escolha o nome completo da sua academia",
    tagline: "Slogan da academia",
    slogan: "Escolha o slogan da sua academia",
    tagline_placeholder: "Escreva aqui o seu slogan",
    my_academy: 'A minha Academia na BrainsPro',

    //ContactComponent
    description: "Descrição",
    web_rrss: "Web e Redes Sociais",
    web_blog: "Web ou Blog",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "Linkedin",
    youtube: "Youtube",
    location: "Localização e Dados Fiscais",
    address_1line: "Endereço, linha 1",
    address_2line: "Endereço, linha 2",
    postalcode: "Código postal",
    city: "Cidade",
    province: "Província",
    country: "País",
    company_name: "Nome da empresa",
    nif_cif: "NIF/CIF",

    //LegalComponent
    privacy_policy: "Política de Privacidade",
    text_register: "Texto de resumo para registo do utilizador",
    user_view_text: "Este texto será exibido no registo do utilizador, como um resumo da versão mais longa que será exibida na página de aviso legal da sua escola.",
    privacy_policy_page: "Página de Política de Privacidade",
    privacy_policy_academy_page: "Página da Política de Privacidade da Academia",
    legal_notice: "Aviso Legal",

    //Contact
    contact_bloq: 'Bloco de contacto',
    html_bloq: 'Insere um bloco html para acompanhar as informações de contacto. Como um iframe do google maps.',

    //Branding
    //BannerBrandingComponent
    upload_banner: 'Carregue o seu banner',
    image_format: 'PNG, JPG, GIF até 3MB',
    banner_size_recommendation: 'Recomendado: imagem panorâmica, com pelo menos 1600×600 px. Em ecrãs pequenos será apresentada completa; em ecrãs grandes será recortada para ocupar toda a largura.',

    //ColorsComponent
    desing_colors: 'Desenho e Cores',
    header_type: 'Tipo de cabeçalho',
    banner_complete: 'Banner em tamanho real',
    banner_complete_no_text: 'Banner em tamanho real sem texto',
    columns_text_image: '2 Colunas, Texto + Imagem',
    banner_info: 'Isto irá alterar o tipo de imagem de capa que os utilizadores verão na sua academia.',
    enterprise_color: 'Cor corporativa',
    text_color: 'Cor do texto',

    //FontsComponent
    desing_fonts: 'Tipografia',
    fonts_info: 'Escolha a fonte que será usada em cada tipo de texto da sua academia.',
    font_h1: 'Título principal (H1)',
    font_h2: 'Subtítulo (H2)',
    font_h3: 'Título de secção (H3)',
    font_body: 'Texto normal',
    font_default: 'Por defeito',

    //FaviconComponent
    favicon: 'Favicon',
    favicon_help: 'Ícone que aparece no separador do navegador.',
    upload_favicon: 'Carregue o seu favicon',
    favicon_format: 'PNG, JPG, GIF até 3MB',

    //LogoBrandingComponent
    logo: 'Logo',
    logo_help: 'Aparece no cabeçalho do site e nos certificados.',
    upload_logo: 'Carregue o seu logótipo',

    //OptionsComponent
    register_config: 'Configuração do registo',
    info_button_register: 'A activação deste botão irá desactivar a opção de registo na academia. Para o fazer, todos os utilizadores devem registar-se a partir da aplicação Brainspro.',
    restricted_register: 'Restrição ao registo',

    //MenuComponent
    menu: 'Menu',
    menu_description: 'Escolha que ligações aparecem no menu superior do site da sua academia e por que ordem.',
    menu_default_notice: 'Ainda não adicionou nenhum elemento, por isso o seu site está a usar o menu predefinido. Assim que adicionar um, o menu mostrará apenas os elementos desta lista.',
    add_menu_item: 'Adicionar elemento',
    edit_menu_item: 'Editar elemento',
    menu_item_edit: 'Editar',
    menu_item_type: 'Tipo',
    menu_item_type_catalog: 'Catálogo',
    menu_item_type_contact: 'Contacto',
    menu_item_type_page: 'Página',
    menu_item_type_link: 'Ligação',
    menu_item_type_home: 'Início',
    menu_item_type_home_help: 'Leva à página principal da sua academia.',
    menu_item_type_catalog_help: 'Leva à página com todos os seus cursos.',
    menu_item_type_contact_help: 'Leva à secção de contacto da sua página inicial.',
    menu_item_type_link_help: 'Leva a qualquer endereço web que escrever.',
    menu_item_title: 'Texto da ligação',
    menu_item_add_translations: 'Adicionar nome noutros idiomas',
    menu_item_hide_translations: 'Ocultar nomes noutros idiomas',
    menu_item_translations: 'Nome noutros idiomas',
    menu_item_translations_example: 'Exemplo: se a ligação se chama "Cursos", em inglês pode escrever "Courses".',
    menu_item_page: 'Página',
    menu_item_select_page: 'Escolha uma página',
    menu_item_page_invalid: 'A página deste elemento já não está disponível. Escolha outra para poder guardar.',
    menu_pages_loading: 'A carregar páginas…',
    menu_pages_error: 'Não foi possível carregar as páginas da academia.',
    menu_no_pages: 'Ainda não tem páginas. Escreva ao suporte e ajudamos a criá-las.',
    menu_page_unavailable: 'Página não disponível',
    menu_page_unavailable_help: 'A página deste elemento já não existe, por isso não é mostrada no site. Edite-o para escolher outra.',
    menu_item_url: 'URL',
    menu_item_url_help: 'Deve começar por https:// ou http://.',
    menu_item_visible: 'Visível no site',
    menu_item_hidden: 'Oculto',
    move_menu_item_up: 'Subir elemento',
    move_menu_item_down: 'Descer elemento',
    drag_menu_item: 'Arraste para reordenar',
    delete_menu_item: 'Eliminar elemento do menu',
    delete_menu_item_confirm: '«{title}» será eliminado do menu. Esta ação não pode ser anulada.',
    menu_item_saved: 'O elemento do menu foi guardado',
    menu_item_deleted: 'O elemento foi eliminado do menu',
    menu_order_saved: 'A ordem do menu foi guardada',
    menu_order_error: 'Não foi possível guardar a ordem do menu. Foi restaurada a ordem anterior.',
    menu_unexpected_error: 'Ocorreu um erro inesperado com o menu',
    menu_item_name_es: 'Nome em espanhol',
    menu_item_name_en: 'Nome em inglês',
    menu_item_name_ca: 'Nome em catalão',
    menu_item_name_de: 'Nome em alemão',
    menu_item_name_pt: 'Nome em português',

}